const appQueries = {
  form: () => ['form'],
  translationList: () => ['translation/list'],
}

export default appQueries
